/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index'

let exports = {};

//TODO
exports.getSysMenuChnlListForRole = function (params, callback) {// 擦擦
    api.post('/setting/sys/menu/chnl/list/get/for/role')
    .data(params)
    .done(callback)
    .go();
};

//系统资源
exports.getSysResc = function (data, callback) {// 获取系统资源
    api.post('/setting/sys/resc/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 获取系统资源操作列表
exports.getSysRescActions = function (data, callback) {
    api.post('/setting/sys/resc/action/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 获取小程序主题-资源
exports.getMiniAppNavTopicListByContext = function (data, callback) {
    api.post('/setting/mini/app/navTopic/list/get/for/role')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/setting.js
// module id = 111
// module chunks = 0